import { render, staticRenderFns } from "./RequestFund.vue?vue&type=template&id=1fb50b3a&scoped=true"
import script from "./RequestFund.vue?vue&type=script&lang=js"
export * from "./RequestFund.vue?vue&type=script&lang=js"
import style0 from "./RequestFund.vue?vue&type=style&index=0&id=1fb50b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb50b3a",
  null
  
)

export default component.exports